import React, { useState, useEffect } from 'react';
import api from '../../api';
import { FaCalculator, FaSave, FaRupeeSign, FaCheckCircle } from 'react-icons/fa';
import styles from './Admin.module.css'; // Shared CSS

const AdminCalculatorRates = () => {
  const [rates, setRates] = useState({
    unitPrice: '',
    costPerKW: '',
    subsidyAmount: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  

  // 1. Fetch Current Rates on Load
  useEffect(() => {
    fetchRates();
  }, []);

  const fetchRates = async () => {
    try {
   const res = await api.get('/Calculator');
      if (res.data) {
        setRates({
          unitPrice: res.data.unitPrice,
          costPerKW: res.data.costPerKW,
          subsidyAmount: res.data.subsidyAmount
        });
      }
    } catch (err) {
      console.error("Error fetching rates", err);
    }
  };

  // 2. Handle Change
  const handleChange = (e) => {
    setRates({ ...rates, [e.target.name]: e.target.value });
  };

  // 3. Update Rates
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const token = localStorage.getItem('token');
      await api.post('/Calculator', rates, {
  headers: { Authorization: `Bearer ${token}` }
});

      setMessage({ text: "Calculator Rates Updated!", type: "success" });
    } catch (err) {
      setMessage({ text: "Update Failed!", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className={styles.formCard} style={{ maxWidth: '600px' }}>
        <h3 style={{ marginBottom: '1.5rem', color: '#4ade80', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaCalculator /> Update Solar Calculator Rates
        </h3>

        {/* Message Box */}
        {message.text && (
          <div style={{
            padding: '12px', marginBottom: '20px', borderRadius: '8px',
            background: message.type === 'error' ? 'rgba(239, 68, 68, 0.15)' : 'rgba(74, 222, 128, 0.15)',
            color: message.type === 'error' ? '#fca5a5' : '#4ade80',
            border: message.type === 'error' ? '1px solid rgba(239, 68, 68, 0.3)' : '1px solid rgba(74, 222, 128, 0.3)',
            display: 'flex', alignItems: 'center', gap: '8px'
          }}>
            {message.type === 'success' && <FaCheckCircle />}
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          
          {/* Unit Price */}
          <div className={styles.formGroup}>
            <label>Electricity Rate (₹ per Unit)</label>
            <div style={{ position: 'relative' }}>
              <input 
                type="number" 
                step="0.01"
                name="unitPrice" 
                value={rates.unitPrice} 
                onChange={handleChange}
                className={styles.formInput} 
                required 
              />
              <FaRupeeSign style={{ position: 'absolute', right: '15px', top: '12px', color: '#94a3b8' }} />
            </div>
            <small style={{ color: '#64748b' }}>Used to calculate monthly savings.</small>
          </div>

          {/* Cost Per KW */}
          <div className={styles.formGroup}>
            <label>Average Installation Cost (₹ per kW)</label>
            <div style={{ position: 'relative' }}>
              <input 
                type="number" 
                name="costPerKW" 
                value={rates.costPerKW} 
                onChange={handleChange}
                className={styles.formInput} 
                required 
              />
              <FaRupeeSign style={{ position: 'absolute', right: '15px', top: '12px', color: '#94a3b8' }} />
            </div>
            <small style={{ color: '#64748b' }}>Used to estimate total project cost.</small>
          </div>

          {/* Subsidy Amount */}
          <div className={styles.formGroup}>
            <label>Max Subsidy Amount (PM Suryaghar)</label>
            <div style={{ position: 'relative' }}>
              <input 
                type="number" 
                name="subsidyAmount" 
                value={rates.subsidyAmount} 
                onChange={handleChange}
                className={styles.formInput} 
                required 
              />
              <FaRupeeSign style={{ position: 'absolute', right: '15px', top: '12px', color: '#94a3b8' }} />
            </div>
            <small style={{ color: '#64748b' }}>Default max subsidy for residential (e.g., 78000).</small>
          </div>

          <button 
            type="submit" 
            className={styles.primaryBtn}
            disabled={loading}
            style={{ marginTop: '15px' }}
          >
            {loading ? 'Updating...' : <><FaSave /> Save New Rates</>}
          </button>
          
        </form>
      </div>
    </div>
  );
};

export default AdminCalculatorRates;